import { STATUS_BACKGROUND_COLORS, STATUS_STROKE } from "../../../_metronic/helpers/StatusBackgroundColorHelpers";

type RenderTransactionStatusRowProps = {
  value?: string;
};

const RenderTransactionStatusRow = ({ value }: RenderTransactionStatusRowProps) => {

  if (!value) {
    return (
      <span style={{
        background: 'transparent',
        padding: '5px 16px',
        borderRadius: '16px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        fontSize: '11px',
        height: '22px',
        fontWeight: '500',
        border: '0.5px solid #ccc',
        lineHeight: '1',
        whiteSpace: 'nowrap',
      }}>
        -
      </span>
    );
  }

  return (
    <span style={{
      background: STATUS_BACKGROUND_COLORS?.[value] ?? 'transparent',
      padding: '5px 16px',
      borderRadius: '16px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: '11px',
      height: '25px',
      width: '80px',
      fontWeight: '500',
      border: `0.5px solid ${STATUS_STROKE?.[value] ?? '#ccc'}`,
      lineHeight: '1',
      whiteSpace: 'nowrap'
    }}>
      {value}
    </span>
  );
};
export { RenderTransactionStatusRow }